import styles from "./Tag.module.scss";
import { TagProps } from "./Tag.types";

const Tag = ({
  label,
  variant = "default",
  variantType = "",
  className = "",
}: TagProps) => (
  <span className={`${styles.tag} ${styles[variant]} ${styles[variantType]} `}>
    {label}
  </span>
);

export default Tag;
